import { coursesFastActionsFilterOptions } from 'enum/coursesFastActionsOptions.enum'

export const prepareSearch = (
  searchText = '',
  usersFilter: any,
  fastFilters: number,
  areaId?: number
) => {
  const q = { g: [{}] } as any

  q['m'] = 'and'
  q['search_name_cont'] = searchText
  if (areaId) {
    q['user_area_id_eq'] = areaId
  }
  if (fastFilters) {
    const { draftCourses, publishedCourses } = coursesFastActionsFilterOptions
    switch (fastFilters) {
      case publishedCourses:
        q['state_eq'] = 1
        break
      case draftCourses:
        q['state_eq'] = 0
        break
      default:
        break
    }
  }

  if (usersFilter) {
    if (usersFilter.filterType === 'simple') {
      q['g'][0]['m'] = usersFilter.generalCondition || 'and'
      const toDelete = [] as string[]
      usersFilter.data.map(({ input, operator, compareTo }: any) => {
        if (q['g'][0][`${input}_${operator}`] && !operator.includes('null')) {
          const op =
            usersFilter.generalCondition === 'and'
              ? `${operator}_all`
              : `${operator}_any`
          toDelete.push(`${input}_${operator}`)
          if (Array.isArray(q['g'][0][`${input}_${op}`])) {
            q['g'][0][`${input}_${op}`].push(compareTo)
          } else {
            q['g'][0][`${input}_${op}`] = [
              q['g'][0][`${input}_${operator}`],
              compareTo,
            ]
          }
        } else {
          q['g'][0][`${input}_${operator}`] = compareTo
        }
      })
      if (toDelete.length)
        toDelete.map((row: string) => {
          delete q['g'][0][row]
        })
    } else {
      q['g'][0]['g'] = []
      usersFilter.groupedData &&
        usersFilter.groupedData.map(({ data, groupCondition, group }: any) => {
          q['g'][0]['m'] = usersFilter.generalCondition
          q['g'][0]['g'].push({ m: '' })
          q['g'][0]['g'][group]['m'] = groupCondition
          const toDelete = [] as string[]
          data.map(({ input, operator, compareTo }: any) => {
            if (q['g'][0]['g'][group][`${input}_${operator}`]) {
              const op =
                groupCondition === 'and' ? `${operator}_all` : `${operator}_any`
              toDelete.push(`${input}_${operator}`)
              if (Array.isArray(q['g'][0]['g'][group][`${input}_${op}`])) {
                q['g'][0]['g'][group][`${input}_${op}`].push(compareTo)
              } else {
                q['g'][0]['g'][group][`${input}_${op}`] = [
                  q['g'][0]['g'][group][`${input}_${operator}`],
                  compareTo,
                ]
              }
            } else {
              q['g'][0]['g'][group][`${input}_${operator}`] = compareTo
            }
          })
          if (toDelete.length)
            toDelete.map((row: string) => {
              delete q['g'][0]['g'][group][row]
            })
        })
    }
  }

  return q
}
